import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}} % de réduction sur les articles sélectionnés',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}} % de réduction sur la valeur totale',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Article offert avec un article',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Article offert avec une valeur de commande',
  [OFFER_KIND.BOGO_HALF_PRICE]: '1 acheté, 1 offert à moitié prix',
  [OFFER_KIND.BOGO]: '1 acheté, 1 offert',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} de réduction sur les articles sélectionnés',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} de réduction sur une valeur de commande',
};
